import React, { useEffect, useRef, useState } from "react";
import "../assets/css/custom.css";
import "../assets/css/client.css";
import "../assets/css/font-awesome.css";
import "../assets/css/sweetalert.css";
import "../assets/css/bootstrap.min.css";
import { FaChevronDown } from "react-icons/fa";
import "../assets/css/steps.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faPlus,
  faSort,
  faEllipsisVertical,
  faTrash,
  faPenToSquare,
} from "@fortawesome/free-solid-svg-icons";
import clientDemoImg from "../assets/img/client.jpg";
import NoBuilding from "../assets/img/no-client.png";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useNavigate, Link } from "react-router-dom";
import ReactDOM from "react-dom";
import { commonAPI } from "../services/CommonAPIService";
import Menus from "./menus";
import { Stepper, Step, StepLabel } from "@mui/material";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import INDFlag from "../assets/img/INDFlag.jpg";
import { ErrorSource } from "../common/constants";
import MultiSelect from 'react-multiselect-dropdown';
import Select from 'react-select';

function Client() {
  const history = useNavigate();
  const [activeStep, setActiveStep] = useState(0);
  const steps = ["Step 1", "Step 2", "Step 3", "Step 4"];
  const [show, setShow] = useState(false);
  const [ClientList, setClientList] = useState(null);
  const [ClientName, setClientName] = useState("");
  const [ShortName, setShortName] = useState("");
  const [Website, setWebsite] = useState("");
  const [PhoneNumber, setPhoneNumber] = useState("");
  const [AltPhoneNumber, setAltPhoneNumber] = useState("");
  const [Email, setEmail] = useState("");
  const [AltEmail, setAltEmail] = useState("");
  const [SpocName, setSpocName] = useState("");
  const [SpocMobileNumber, setSpocMobileNumber] = useState("");
  const [SpocEmail, setSpocEmail] = useState("");
  const [AltSPOCName, setAltSPOCName] = useState("");
  const [AltSPOCMobileNumber, setAltSPOCMobileNumber] = useState("");
  const [AltSPOCEmail, setAltSPOCEmail] = useState("");
  const [AddressLine1, setAddressLine1] = useState("");
  const [AddressLine2, setAddressLine2] = useState("");
  const [City, setCity] = useState("");
  const [SelectCity, setSelectCity] = useState("");
  const [State, setState] = useState("");
  const [SelectState, setSelectState] = useState("");
  const [Country, setCountry] = useState("");
  const [SelectCountry, setSelectCountry] = useState("");
  const [PinCode, setPinCode] = useState("");
  const [Logo, setLogo] = useState("");
  const [ClientSubscriptionKey, setClientSubscriptionKey] = useState("");
  const [ClientId, setClientId] = useState("");
  const [Loading, setLoading] = useState(false);
  const [ProductName, setProductName] = useState([]);
  const [selectedProductIds, setSelectedProductIds] = useState([]);  // Array to hold selected product IDs
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [ProductId, setProductId] = useState();
  const [ProductMultipleId, setProductMultipleId] = useState();
  const [ClientDisplayName, setClientDisplayName] = useState();
  const [UserData, setUserData] = useState("");
  const [AddClient, setAddClient] = useState(false);
  const [UpdateClientBtn, setUpdateClientBtn] = useState(false);
  const [oldVehicleIndex, setOldVehicleIndex] = useState(null);
  const [vehicleMenu, showVehicleMenu] = useState(false);
  const [selectedImageTwo, setSelectedImageTwo] = useState(null);
  const [selectedImageTwoShow, setSelectedImageTwoShow] = useState(null);
  const [ProductNameShow, setProductNameShow] = useState(false);
  const [isStateChange, setIsStateChange] = useState(false);
  const [updatedProductItem, setUpdatedProductItem] = useState(null);
const [removedProductItem, setRemovedProductItem] = useState(null);
  // console.log("SelectCountry", State)
  // console.log("PinCode", PinCode)
  console.log("selectedProductIds", selectedProductIds)

  const [reset, setReset] = useState(0);
  const values = [true, "sm-down", "md-down", "lg-down", "xl-down", "xxl-down"];
  const [fullscreen, setFullscreen] = useState(true);


 
 

  const setInputValue = (item) => {
    setTimeout(() => {
      setIsStateChange(true);
    }, 100);


    setShow(true)
    setAddClient(false);
    setUpdateClientBtn(true)
    // console.log("item", item)
    setClientId(item?.clientId)
    setClientName(item?.clientName)
    setClientDisplayName(item?.clientDisplayName)
    setShortName(item?.clientShortName)
    setProductId(item?.clientProductId)
    setWebsite(item?.website)
    setPhoneNumber(item?.phoneNumber)
    setAltPhoneNumber(item?.altPhoneNumber)
    setEmail(item?.email)
    setAltEmail(item?.altEmail)
    setSpocName(item?.spocName)
    setSpocEmail(item?.spocEmail)
    setSpocMobileNumber(item?.spocMobileNumber)
    setAltSPOCName(item?.altSPOCName)
    setAltSPOCMobileNumber(item?.altSPOCMobileNumber)
    setAltSPOCEmail(item?.altSPOCEmail)
    setAddressLine1(item?.addressLine1)
    setAddressLine2(item?.addressLine2)

    setSelectCountry(["1", "India"])
    GetStateList()
    const itemState = item?.state
    const stateObj = State?.filter((item) => item?.stateName == itemState);
    // console.log("updated State arry", [stateObj[0]?.stateId, stateObj[0]?.stateName]);
    setSelectState([stateObj[0]?.stateId, stateObj[0]?.stateName])
    CityUpdate();
    // GetCityList();
    // const itemCity = item?.city
    // const cityObj = State.filter((item)=> item.cityId == itemCity);
    // console.log("updated City arry", item?.city);
    setSelectCity(item?.city);
    setPinCode(item?.pinCode)
    // var decodedString2 = atob(item?.logo);
    // // console.log("atob", decodedString2)
    // const addBase64 = item?.logo;
    setSelectedImageTwo(item?.logo)
    setSelectedImageTwoShow(item?.logo)
    setClientSubscriptionKey(item?.clientSubscriptionKey)
    setProductNameShow(false)
  };

  const CloseModal = () => {
    setShow(false)
    setSelectState("")
    setSelectCity("")
    setIsStateChange(false)
  }

  const openCreateModal = () => {
    setShow(true)
    setSelectedProductIds("")
    setAddClient(true);
    setUpdateClientBtn(false)
    setProductNameShow(true)
    setShortName("")
    setWebsite("")
    setClientName("")
    setClientDisplayName("")
    setPhoneNumber("")
    setAltPhoneNumber('')
    setEmail("")
    setAltEmail("")
    setSpocName("")
    setSpocEmail("")
    setSpocMobileNumber("")
    setAltSPOCName("")
    setAltSPOCMobileNumber("")
    setAltSPOCEmail("")
    setAddressLine1("")
    setAddressLine2("")
    setSelectCity("")
    setSelectState("")
    setSelectCountry(["1", "India"])
    setPinCode("")
    setLogo("")
    setClientSubscriptionKey("")
    setSelectedImageTwo("")
    setSelectedImageTwoShow("")
  }
  useEffect(() => {
    ProductApi();
    // GetClientList();
    GetCountryList();
  }, []);

  

  const ProductApi = async () => {
    const auth = localStorage.getItem("userData");
    const myUserData = JSON.parse(auth);
    setUserData(myUserData);
    try {
      // setLoading(true);
      let response = await commonAPI("CuroProducts");
      if (response?.success === true) {
        const tempData = response?.data?.map((item) => {return {value: item?.primeProductCode, label: item?.productName,}});
        setProductName(tempData);
        setProductId(response?.data?.[2].primeProductCode)
        // setSelectedProducts([tempData[2]]);
        console.log("Productfiltered", response?.data?.[2].primeProductCode);
        // setLoading(false);
      } else {
        // alert("Something went wrong");
        toast.error("Something went wrong");
        // setLoading(false);
      }
    } catch (error) {
      // console.log(error);

      setLoading(false);
      const bodydata = {
        userId: UserData.userId,
        mobileNumber: UserData.mobileNumber,
        requestJSON: null,
        uri: "/api/Common/CuroProducts",
        errorNumber: "PL01",
        errorSource: ErrorSource,
        errorSummary: error.message,
        errorDescription: error.message,
        fileClassName: "client.js",
        functionName: "ProductApi",
      };
      // console.log("body", bodydata);
      let response = await commonAPI("ErrorLogMaster", bodydata);
      // console.log("statusCode", response);
      if (response?.success == true && response?.message?.length == 0) {
        toast.error("Something went wrong");
        setLoading(false);
      } else {
        setLoading(false);
        toast.error("Something went wrong");
      }
    }
  };

  const handleMultiSelectChange = (selectedOptions) => {
    console.log("Selected Options are", selectedOptions);
  
    // Ensure selectedOptions is defined
    const currentSelectedOptions = selectedOptions || []; // Default to empty array if undefined
    const previousSelectedOptions = selectedProductIds || []; // Default to empty array if undefined
  
    // If a new option is added
    if (currentSelectedOptions.length > previousSelectedOptions.length) {
      const addedItem = currentSelectedOptions.find(
        item => !previousSelectedOptions.some(selected => selected.value === item.value)
      );
      // console.log('Added item:', addedItem);
      setUpdatedProductItem(addedItem); // Track the newly added product
    }
  
    // If an option is removed
    if (currentSelectedOptions.length < previousSelectedOptions.length) {
      const removedItem = previousSelectedOptions.find(
        item => !currentSelectedOptions.some(selected => selected.value === item.value)
      );
      // console.log('Removed item:', removedItem);
      setRemovedProductItem(removedItem); // Track the removed product
    }
  
    // Update the state with new selected options
    setSelectedProductIds(currentSelectedOptions);
  
    // Calculate the multiplication of selected values
    const selectedValues = currentSelectedOptions.map(option => option.value);
    const multiplicationResult = multiplyNumbers(selectedValues);
    setProductMultipleId(multiplicationResult);
    // console.log("Multiplication Result:", multiplicationResult); // Log the result or handle as needed
  };
  

  // Function to multiply numbers
  const multiplyNumbers = (numbers) => {
    // Check if the input array has exactly 5 elements
    // if (numbers.length != 1) {
    //   throw new Error("Input array must contain exactly 5 numbers.");
    // }

    // Use reduce to multiply the numbers together
    return numbers.reduce((accumulator, currentValue) => accumulator * currentValue, 1);
  };

  


  function setVehicleIndex(index) {
    // console.log(oldVehicleIndex == index, "oldVehicleIndex==index");
    if (oldVehicleIndex == index) {
      setOldVehicleIndex(null);
      showVehicleMenu(null);
    } else {
      showVehicleMenu(index);
      setOldVehicleIndex(index);
    }
    // setHideVehicleMenu(true)
  }

  useEffect(() => {
    const storedUsername = localStorage.getItem('userData');
    // console.log("useEffect Local storage name", storedUsername)
    if (storedUsername) {
      // If the username is present, redirect to the dashboard
      history('/Configuration');
      // console.log("useEffect Local storage Yes")
    }
    else if (storedUsername === null) {
      history('/');
      // console.log("useEffect Local storage No")
    }
  }, [history]);

  const GetCountryList = async () => {
    try {
      // setLoading(true);
      let response = await commonAPI("Country");
      // console.log("Country", response);
      if (response.success === true) {

        setCountry(response.data);
        // setLoading(false);
        setSelectCountry(["1", "India"])
      } else {
        toast.error("Something went wrong");
        // setLoading(false);
      }
    } catch (error) {
      // console.log(error);

      setLoading(false);
      const bodydata = {
        userId: UserData.userId,
        mobileNumber: UserData.mobileNumber,
        requestJSON: null,
        uri: "api/Common/Country",
        errorNumber: "CL01",
        errorSource: ErrorSource,
        errorSummary: error.message,
        errorDescription: error.message,
        fileClassName: "client.js",
        functionName: "GetCountryList",
      };
      // console.log("body", bodydata);
      let response = await commonAPI("ErrorLogMaster", bodydata);
      // console.log("statusCode", response);
      if (response?.success == true && response?.message.length == 0) {
        toast.error("Something went wrong");
        setLoading(false);
      } else {
        setLoading(false);
        toast.error("Something went wrong");
      }
    }
  };


  const GetStateList = async () => {
    try {
      // setLoading(true);
      let response = await commonAPI("State", undefined, SelectCountry[0]);
      // console.log("State", response);
      if (response?.success === true) {

        setState(response?.data);
        // setLoading(false);

      } else {
        toast.error("Something went wrong");
        // setLoading(false);
      }
    } catch (error) {
      // console.log(error);

      setLoading(false);
      const bodydata = {
        userId: UserData?.userId,
        mobileNumber: UserData?.mobileNumber,
        requestJSON: null,
        uri: "api/Common/State",
        errorNumber: "SL01",
        errorSource: ErrorSource,
        errorSummary: error?.message,
        errorDescription: error?.message,
        fileClassName: "client.js",
        functionName: "GetStateList",
      };
      // console.log("body", bodydata);
      let response = await commonAPI("ErrorLogMaster", bodydata);
      // console.log("statusCode", response);
      if (response?.success == true && response?.message?.length == 0) {
        toast.error("Something went wrong");
        setLoading(false);
      } else {
        setLoading(false);
        toast.error("Something went wrong");
      }
    }
  };


  // const StateUpdate = async () => {
  useEffect(() => {
    if (SelectCountry) {
      GetStateList();
    }

  }, [SelectCountry]);
  // }
  useEffect(() => {
    // if(ProductId){
    GetClientList();
    // }
  }, []);

  const GetCityList = async () => {
    try {
      // setLoading(true);
      // console.log("getCityList 12", SelectState[0])
      let response = await commonAPI("City", undefined, SelectState[0]);
      // console.log("State", response);
      if (response?.success === true) {

        setCity(response?.data);
        // setLoading(false);
        // console.log("City API", response?.data)

      } else {
        toast.error("Something went wrong");
        // setLoading(false);
      }
    } catch (error) {
      // console.log(error);

      setLoading(false);
      const bodydata = {
        userId: UserData?.userId,
        mobileNumber: UserData?.mobileNumber,
        requestJSON: null,
        uri: "api/Common/City",
        errorNumber: "CL01",
        errorSource: ErrorSource,
        errorSummary: error?.message,
        errorDescription: error?.message,
        fileClassName: "client.js",
        functionName: "GetCityList",
      };
      // console.log("body", bodydata);
      let response = await commonAPI("ErrorLogMaster", bodydata);
      // console.log("statusCode", response);
      if (response?.success == true && response?.message?.length == 0) {
        toast.error("Something went wrong");
        setLoading(false);
      } else {
        setLoading(false);
        toast.error("Something went wrong");
      }
    }
  };

  useEffect(() => {
    if (!UpdateClientBtn) {
      if (SelectState[0]) {
        GetCityList();
        setSelectCity("0")
        // console.log("it is run")
      }
    } else {
      if (SelectState[0]) {
        GetCityList();
        // console.log("it is run")
      }
    }

  }, [SelectState[0], UpdateClientBtn]);

  useEffect(() => {

    if (SelectState[0] && isStateChange) {
      setSelectCity("0")
    }

  }, [SelectState[0]]);


  const CityUpdate = async () => {
    if (SelectState[0]) {
      GetCityList();
    }
  }
  const CheckCity = async () => {
    if (!SelectState && SelectState == 0) {
      toast.warning("Please select state");
    }
  }

  const GetClientList = async () => {
    const auth = localStorage.getItem("primeProductCode");
        const ProductfactorKey = JSON.parse(auth);
        console.log("primeProductCode", ProductfactorKey)
        const endPointVariableKey = {
            ProductId: ProductfactorKey?.primeProductCode,
        }
    try {
      setLoading(true);
      let response = await commonAPI("Client", undefined, endPointVariableKey);
      console.log("Table client", response?.data);
      if (response?.success === true) {
        setClientList(response?.data);
        setLoading(false);
      } else {
        toast.error("Something went wrong");
        setLoading(false);
      }
    } catch (error) {
      // console.log(error);

      setLoading(false);
      const bodyError = {
        userId: UserData?.userId,
        mobileNumber: UserData?.mobileNumber,
        requestJSON: null,
        uri: "/api/Master/Client",
        errorNumber: "CL01",
        errorSource: ErrorSource,
        errorSummary: error?.message,
        errorDescription: error?.message,
        fileClassName: "client.js",
        functionName: "GetClientList",
      };
      let response = await commonAPI("ErrorLogMaster", bodyError);
      // console.log("statusCode", response);
      if (response?.success == true && response?.message.length == 0) {
        toast.error("Something went wrong");
        setLoading(false);
      } else {
        setLoading(false);
        toast.error("Something went wrong");
      }
    }
  };

  



  const AddClientData = async () => {
    // console.log("addclint")
    const bodydata = {
      createdUserId: UserData.userId.toString(),
      clientName: ClientName,
      clientDisplayName: ClientDisplayName,
      clientShortName: ShortName,
      clientProductId: ProductMultipleId,
      website: Website,
      phoneNumber: PhoneNumber,
      altPhoneNumber: AltPhoneNumber,
      email: Email,
      altEmail: AltEmail,
      spocName: SpocName,
      spocMobileNumber: SpocMobileNumber,
      spocEmail: SpocEmail,
      altSPOCName: AltSPOCName,
      altSPOCMobileNumber: AltSPOCMobileNumber,
      altSPOCEmail: AltSPOCEmail,
      addressLine1: AddressLine1,
      addressLine2: AddressLine2,
      city: SelectCity,
      state: SelectState[1],
      country: SelectCountry[1],
      pinCode: PinCode,
      // "logo": Logo,
      logo: selectedImageTwoShow,
      //   clientSubscriptionKey: ClientSubscriptionKey,
    };
    try {
      setLoading(true);
      if (selectedProductIds.length == 0) {
        setLoading(false);
        toast.warning("Please select Client");
      }else if (!selectedImageTwo) {
        setLoading(false);
        toast.warning("Please upload Logo");
      } else if (!ClientName) {
        setLoading(false);
        toast.warning("Please enter Client Name");
      } else if (!ClientDisplayName) {
        setLoading(false);
        toast.warning("Please enter Client Display Name");
      } else if (!ShortName) {
        setLoading(false);
        toast.warning("Please enter Short Name");
      } else if (!Website) {
        setLoading(false);
        toast.warning("Please enter Website");
      } else if (!PhoneNumber) {
        setLoading(false);
        toast.warning("Please enter Phone Number");
      } 
      else if ( PhoneNumber?.length != 10) {
        setLoading(false);
        toast.warning("Please enter valid Phone Number");
      } 
      else if (!Email) {
        setLoading(false);
        toast.warning("Please enter Email");
      } else if (!AddressLine1) {
        setLoading(false);
        toast.warning("Please enter Address Line 1");
      } else if (!SelectCountry) {
        setLoading(false);
        toast.warning("Please select Country");
      } else if (!SelectState || SelectState == "0") {
        setLoading(false);
        toast.warning("Please select State");
      } else if (!SelectCity || SelectCity == "0") {
        setLoading(false);
        toast.warning("Please select City");
      } else if (!PinCode) {
        setLoading(false);
        toast.warning("Please enter Pincode");
      } else {
        // console.log("AddBody", bodydata);
        let response = await commonAPI("ClientAdd", bodydata);
        // console.log("statusCode", response);
        if (response.success == true && response.message.length == 0) {
          //   alert("Client Added");
          toast.success("Client Added");
          setLoading(false);
          setShow(false);
          setShow(false)
          setSelectState("")
          setSelectCity("")
          setIsStateChange(false)
          GetClientList();
        } else {
          toast.error(response.message[0]);
          setLoading(false);
        }
      }
    } catch (error) {
      setLoading(false);
      const bodyError = {
        userId: UserData.userId,
        mobileNumber: UserData.mobileNumber,
        requestJSON: bodydata,
        uri: "/api/Master/Client",
        errorNumber: "AC01",
        errorSource: ErrorSource,
        errorSummary: error.message,
        errorDescription: error.message,
        fileClassName: "client.js",
        functionName: "AddClientData",
      };
      let response = await commonAPI("ErrorLogMaster", bodyError);
      // console.log("statusCode", response);
      if (response?.success == true && response?.message?.length == 0) {
        toast.error("Something went wrong");
        setLoading(false);
      } else {
        setLoading(false);
        toast.error("Something went wrong");
      }
    }
  };
  // console.log(activeStep, "activeStep");

  const UpdateClient = async () => {
    // console.log(!PhoneNumber && PhoneNumber.length != 10,"CHECKING")
    const auth = localStorage.getItem("userData");
    const myUserData = JSON.parse(auth);
    const bodydata = {
      modifiedUserId: JSON.stringify(myUserData?.userId), // Need to be change
      clientId: ClientId,
      createdUserId: JSON.stringify(myUserData?.userId), // Need to be change
      clientName: ClientName,
      clientDisplayName: ClientDisplayName,
      clientShortName: ShortName,
      website: Website,
      phoneNumber: PhoneNumber,
      altPhoneNumber: AltPhoneNumber,
      email: Email,
      altEmail: AltEmail,
      spocName: SpocName,
      spocMobileNumber: SpocMobileNumber,
      spocEmail: SpocEmail,
      altSPOCName: AltSPOCName,
      altSPOCMobileNumber: AltSPOCMobileNumber,
      altSPOCEmail: AltSPOCEmail,
      addressLine1: AddressLine1,
      addressLine2: AddressLine2,
      city: SelectCity,
      state: SelectState[1],
      country: SelectCountry[1],
      pinCode: PinCode,
      logo: selectedImageTwoShow,
    };
    try {
      setLoading(true);

      if (!selectedImageTwo) {
        setLoading(false);
        toast.warning("Please upload Logo");
      } else if (!ClientName) {
        setLoading(false);
        toast.warning("Please enter Client Name");
      } else if (!ClientDisplayName) {
        setLoading(false);
        toast.warning("Please enter Client Display Name");
      } else if (!ShortName) {
        setLoading(false);
        toast.warning("Please enter Short Name");
      } else if (!Website) {
        setLoading(false);
        toast.warning("Please enter Website");
      } else if (!PhoneNumber ) {
 
        setLoading(false);
        toast.warning("Please enter Phone Number");
      }
      else if ( PhoneNumber.length != 10) {
        
        setLoading(false);
        toast.warning("Please enter Valid Phone Number");
      }
      else if (!Email) {
        setLoading(false);
        toast.warning("Please enter Email");
      } else if (!AddressLine1) {
        setLoading(false);
        toast.warning("Please enter Address Line 1");
      } else if (!SelectCountry) {
        setLoading(false);
        toast.warning("Please select Country");
      } else if (!SelectState || SelectState == "0") {
        setLoading(false);
        toast.warning("Please select State");
      } else if (!SelectCity || SelectCity == "0") {
        setLoading(false);
        toast.warning("Please select City");
      } else if (!PinCode) {
        setLoading(false);
        toast.warning("Please enter Pincode");
      } else {
        console.log("bodyData", bodydata);
        let response = await commonAPI("ClientUpdate", bodydata);
        // console.log("Update Client", response);
        if (response.success == true) {
          toast.success("Client Updated");
          setShow(false);
          setLoading(false);
          GetClientList();
          setShow(false)
          setSelectState("")
          setSelectCity("")
          setIsStateChange(false)
          // console.log("Update Clientifffff", response)
        } else {
          toast.error(response.message[0]);
          setLoading(false);
          // console.log("Update Clientelse", response)
        }
      }
    } catch (error) {
      setLoading(false);
      const bodyError = {
        userId: UserData?.userId,
        mobileNumber: UserData?.mobileNumber,
        requestJSON: bodydata,
        uri: "/api/Master/Client",
        errorNumber: "UC01",
        errorSource: ErrorSource,
        errorSummary: error?.message,
        errorDescription: error?.message,
        fileClassName: "client.js",
        functionName: "UpdateClient",
      };
      let response = await commonAPI("ErrorLogMaster", bodyError);
      // console.log("statusCode", response);
      if (response?.success == true && response?.message?.length == 0) {
        toast.error("Something went wrong");
        setLoading(false);
      } else {
        setLoading(false);
        toast.error("Something went wrong");
      }
    }
  };

  const handleNext = () => {
    setActiveStep((prevActiveStep) => {
      if (prevActiveStep >= steps.length - 1) {
        // Assuming 'steps' is your array of step labels
        return 0; // Reset to first step
      } else {
        // console.log(inpRef.current.value)
        return prevActiveStep + 1;
      }
    });
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const useToggle = (initialState) => {
    const [toggleValue, setToggleValue] = useState(initialState);

    const toggler = () => {
      setToggleValue(!toggleValue);
    };
    return [toggleValue, toggler];
  };

  const handleFileInputChangeTwo = (event) => {
    const file = event.target.files[0];
    // console.log("btoa111111111111", file?.size);
    // console.log("btoa222222222222", file?.type);
    if (file) {
      if (!/\.(jpeg|jpg|png)$/i.test(file?.name)) {
        toast.error("Please select an image in JPEG, JPG, or PNG format.");
      } else if (file?.size >= 50000) {
        toast.error("Please select a logo with a size below 50KB.");
      } else {
        const reader = new FileReader();

        reader.onload = () => {
          // const SplitBase64 = reader.result.split("base64,");
          // // console.log("SplitBase64======", SplitBase64[1])
          // const encodedString = btoa(reader.result);
          setSelectedImageTwo(reader.result);
          setSelectedImageTwoShow(reader.result);
        };
        reader.readAsDataURL(file);
      }

    }
  };

  const handleChangePincode = (e) => {
    const value = e.target.value;
    // Remove non-digit characters and limit to 6 digits
    const cleanedValue = value.replace(/\D/g, '').slice(0, 6);
    setPinCode(cleanedValue);
    
  };

  return (
    <>
      {Loading ? (
        <div className="loaderDiv">
          <div className="loader"></div>
        </div>
      ) : null}
      <ToastContainer />
      <div className="row mt-5 pt-5" style={{ alignItem: 'center' }}>
        <div className="col-md-4">
          <div className="HeadingTop">
            <h3> Clients </h3>
            <span> Maintain and create detailed records of all clients.</span>
          </div>
        </div>
        <div className="col-md-3 offset-md-5 text-right mb-3 mb-md-0" style={{ alignContent: 'center' }}>
          <Button onClick={() => openCreateModal()} className="createClr">+ Create New</Button>{" "}
        </div>
      </div>
      
      <Modal scrollable
        fullscreen={fullscreen}
        show={show}
        onHide={() =>
          CloseModal()}
        dialogclassName="modal-100w clientmodal"
        class="modal-dialog modal-fullscreen"
      >
        <Modal.Header className="headerMDL" closeButton>
          <Modal.Title onClick={openCreateModal}>{ProductNameShow ? <>Add Client</> : <>Update Client</>}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row" id="validation">
            <div className="col-12">
              <form
                action="#"
                className="validation-wizard wizard-circle wizard clearfix"
                role="application"
                id="steps-uid-0"
                novalidate="novalidate"
              >
              
                <div>
                  <div className="row">
                    <div className="col-lg-2 col-md-2 col-sm-12 col-12 border_area">
                      <div className="form-group">
                        <label for="webUrl3" className="mt-4">Logo <span className="danger">*</span></label>
                        {/* <input type="file" onChange={(e)=>handleFileInputChangeTwo(e)} className="form-control required"  name="webUrl3" aria-required="true" />
                                <div className='img_uploaded'>
                                    {selectedImageTwo && <img src={selectedImageTwo} alt="Selected Image" />}
                                </div> */}
                        <br />
                        {!selectedImageTwo ?
                          <div className='img_uploaded'>
                            <img src={clientDemoImg} alt="Selected Image" />
                          </div>
                          : <div className='img_uploaded'>
                            {selectedImageTwo && <img src={selectedImageTwo} alt="Selected Image" />}
                          </div>

                        }


                        <label for="file-upload" className="custom-file-upload">
                          Browse Logo
                        </label>
                        <input id="file-upload" type="file" onChange={(e) => handleFileInputChangeTwo(e)} />
                        <label className="text-danger mb-0"><span className="danger">*</span>{""} Allowed File Types- JPEG/JPG/PNG.</label>
                        <label className="text-danger mb-0"><span className="danger">*</span>{""}Maximum image size - 50KB</label>
                      </div>
                    </div>
                    <div className="col-lg-10 col-md-10 col-sm-12 col-12">
                      <div className="row">
                        {ProductNameShow ?
                          <div className="col-md-4 mb-2">
                            <div className="form-group">
                              <label htmlFor="exampleInputEmail1">
                                {" "}
                                Product Name <span className="danger">*</span>
                              </label>
                              <Select
                                  // defaultValue={TowerSelected}
                                  isMulti
                                  
                                  options={ProductName}
                                  value={selectedProductIds}
                                  // onChange={(event) =>(setTowerSelected(event))}
                                  onChange={handleMultiSelectChange}
                                  hidePlaceholder={true}
                                  placeholder="Select Products"
                                  // selectedValues={TowerSelected} // Preselected value to persist in dropdown
                                  // onSelect={(event) =>(setTowerSelected(event))} // Function will trigger on select event
                                  // onRemove={(event) =>(setTowerSelected(event))} // Function will trigger on remove event
                                  displayValue="name" // Property name to display in the dropdown options
                                  
                              />
                              
                            </div>
                          </div>
                          : null}
                        <div className="col-md-4 mb-2">
                          <div className="form-group">
                            <label for="wfirstName2">
                              {" "}
                              Client Name  <span className="danger">*</span>{" "}
                            </label>
                            <input
                              type="text"
                              value={ClientName}
                              onChange={(e) => {
                                setClientName(e.target.value);
                              }}
                              //  required="required"
                              //  required
                              className="form-control required"
                              //  id="wfirstName2"
                              name="firstName"
                              aria-required="true"
                            />
                          </div>
                        </div>
                        <div className="col-md-4 mb-2">
                          <div className="form-group">
                            <label for="wfirstName2">
                              {" "}
                              Client Display Name {" "}
                              <span className="danger">*</span>{" "}
                            </label>
                            <input
                              type="text"
                              value={ClientDisplayName}
                              onChange={(e) => {
                                setClientDisplayName(e.target.value);
                              }}
                              className="form-control required"
                              id="wfirstName2"
                              name="firstName"
                              aria-required="true"
                            />
                          </div>
                        </div>
                        <div className="col-md-4 mb-2">
                          <div className="form-group">
                            <label for="wlastName2">
                              {" "}
                              Short Name  <span className="danger">
                                *
                              </span>{" "}
                            </label>
                            <input
                              type="text"
                              value={ShortName}
                              className="form-control required"
                              onChange={(e) => {
                                setShortName(e.target.value);
                              }}
                              id="wlastName2"
                              name="lastName"
                              aria-required="true"
                            />{" "}
                          </div>
                        </div>

                        <div className="col-md-4 mb-2">
                          <div className="form-group">
                            <label for="wlastName2">
                              {" "}
                              Website  <span className="danger">*</span>{" "}
                            </label>
                            <input
                              type="text"
                              value={Website}
                              onChange={(e) => setWebsite(e.target.value)}
                              className="form-control required"
                              id="wlastName2"
                              name="lastName"
                              aria-required="true"
                            />{" "}
                          </div>
                        </div>
                        <div className="col-md-4 mb-2">
                          <div className="form-group">
                            <label for="wemailAddress2">
                              {" "}
                              Phone Number  <span className="danger">*</span>{" "}
                            </label>
                            <input
                              type="email"
                              value={PhoneNumber}
                              onChange={(e) => setPhoneNumber(e.target.value)}
                              className="form-control required"
                              id="wemailAddress2"
                              name="emailAddress"
                              aria-required="true"
                            />{" "}
                          </div>
                        </div>
                        <div className="col-md-4 mb-4">
                          <div className="form-group">
                            <label for="wphoneNumber2">
                              Alt Phone Number
                            </label>
                            <input
                              type="tel"
                              value={AltPhoneNumber}
                              onChange={(e) =>
                                setAltPhoneNumber(e.target.value)
                              }
                              className="form-control"
                              id="wphoneNumber2"
                            />{" "}
                          </div>
                        </div>
                        <div className="col-md-4 mb-4">
                          <div className="form-group">
                            <label for="wlastName2">
                              {" "}
                              Email  <span className="danger">*</span>{" "}
                            </label>
                            <input
                              type="text"
                              value={Email}
                              onChange={(e) => setEmail(e.target.value)}
                              className="form-control required"
                              id="wlastName2"
                              name="lastName"
                              aria-required="true"
                            />{" "}
                          </div>
                        </div>
                        <div className="col-md-4 mb-4">
                          <div className="form-group">
                            <label for="jobTitle2">Alt Email </label>
                            <input
                              type="text"
                              value={AltEmail}
                              onChange={(e) => setAltEmail(e.target.value)}
                              className="form-control required"
                              id="jobTitle2"
                              aria-required="true"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                          <div class="row">
                            <div className="col-lg-2 col-md-6 col-sm-12 mb-4">
                              <div className="form-group">
                                <label >SPOC Name </label>
                                <input type="url" value={SpocName} onChange={(e) => setSpocName(e.target.value)} className="form-control required" id="webUrl3" name="webUrl3" aria-required="true" />
                              </div>
                            </div>
                            <div className="col-lg-2 col-md-6 col-sm-12 mb-4">
                              <div className="form-group">
                                <label >SPOC Mobile No </label>
                                <input type="url" value={SpocMobileNumber} onChange={(e) => setSpocMobileNumber(e.target.value)} className="form-control required" id="webUrl3" name="webUrl3" aria-required="true" />
                              </div>
                            </div>
                            <div className="col-lg-2 col-md-6 col-sm-12 mb-4">
                              <div className="form-group">
                                <label for="jobTitle2">SPOC Email</label>
                                <input type="text" value={SpocEmail} onChange={(e) => setSpocEmail(e.target.value)} className="form-control required" id="jobTitle2" aria-required="true" />
                              </div>
                            </div>
                            <div className="col-lg-2 col-md-6 col-sm-12 mb-4">
                              <div className="form-group">
                                <label >Alt SPOC Name </label>
                                <input type="url" value={AltSPOCName} onChange={(e) => setAltSPOCName(e.target.value)} className="form-control required" id="webUrl3" name="webUrl3" aria-required="true" />
                              </div>
                            </div>
                            <div className="col-lg-2 col-md-6 col-sm-12 mb-4">
                              <div className="form-group">
                                <label >Alt SPOC Mobile No</label>
                                <input type="url" value={AltSPOCMobileNumber} onChange={(e) => setAltSPOCMobileNumber(e.target.value)} className="form-control required" id="webUrl3" name="webUrl3" aria-required="true" />
                              </div>
                            </div>
                            <div className="col-lg-2 col-md-6 col-sm-12 mb-4">
                              <div className="form-group">
                                <label for="jobTitle2">Alt SPOC Email</label>
                                <input type="text" value={AltSPOCEmail} onChange={(e) => setAltSPOCEmail(e.target.value)} className="form-control required" id="jobTitle2" aria-required="true" />
                              </div>
                            </div>
                            <div className="col-lg-2 col-md-6 col-sm-12 mb-4">
                              <div className="form-group">
                                <label >Address Line 1 <span className="danger">*</span></label>
                                <input type="url" value={AddressLine1} onChange={(e) => setAddressLine1(e.target.value)} className="form-control required" id="webUrl3" name="webUrl3" aria-required="true" />
                              </div>
                            </div>
                            <div className="col-lg-2 col-md-6 col-sm-12 mb-4">
                              <div className="form-group">
                                <label >Address Line 2</label>
                                <input type="url" value={AddressLine2} onChange={(e) => setAddressLine2(e.target.value)} className="form-control required" id="webUrl3" name="webUrl3" aria-required="true" />
                              </div>
                            </div>
                            <div className="col-lg-2 col-md-6 col-sm-12 mb-4">
                              <div className="form-group fixChevron">
                                <label >Country <span className="danger">*</span></label>
                                <select name="taskTypes" className="form-control" value={SelectCountry} onChange={(e) =>
                                  setSelectCountry(e.target.value)} disabled>
                                  {/* <option value="0">Select country</option> */}
                                  {Country ? Country?.map((item, index) => (
                                    <option key={index} value={[item?.countryId, item?.countryName]}> {item?.countryName} </option>
                                  ))
                                    : null}
                                </select>
                                <FaChevronDown className="absChevron" size={"10px"}/>   
                                {/* <input type="url" value={Country} onChange={(e) => setCountry(e.target.value)} className="form-control required" id="webUrl3" name="webUrl3" aria-required="true" />  */}
                              </div>
                            </div>
                            <div className="col-lg-2 col-md-6 col-sm-12 mb-4">
                              <div className="form-group fixChevron">
                                <label>State <span className="danger">*</span></label>
                                <select name="taskTypes" className="form-control" value={SelectState} onChange={(e) => {
                                  setSelectState(e?.target?.value?.split(","))
                                }} onClick={CityUpdate}>
                                  <option value="0">Select state</option>
                                  {State ? State?.map((item, index) => (
                                    <option key={index} value={[item?.stateId, item?.stateName]}> {item?.stateName} </option>
                                  ))
                                    : null}
                                </select>
                                <FaChevronDown className="absChevron" size={"10px"}/>   
                              </div>
                            </div>
                            <div className="col-lg-2 col-md-6 col-sm-12 mb-4">
                              <div className="form-group fixChevron">
                                <label for="jobTitle2">City <span className="danger">*</span></label>
                                <select name="taskTypes" className="form-control" value={SelectCity} onChange={(e) =>
                                  setSelectCity(e.target.value)} onClick={CheckCity}>
                                  <option value="0">Select city</option>
                                  {City ? City?.map((item, index) => (
                                    <option key={index} value={item?.cityName}> {item?.cityName} </option>
                                  ))
                                    : null}
                                 
                                </select>
                                <FaChevronDown className="absChevron" size={"10px"}/>   
                                
                                {/* <input type="text" value={City} onChange={(e) => setCity(e.target.value)} className="form-control required" id="jobTitle2" aria-required="true" /> */}
                              </div>
                            </div>


                            <div className="col-lg-2 col-md-6 col-sm-12 mb-4">
                              <div className="form-group">
                                <label for="jobTitle2">Pincode <span className="danger">*</span></label>
                                <input type="number" value={PinCode}  maxlength="6" onChange={(e) => {setPinCode(e.target.value); handleChangePincode(e)}} className="form-control required" id="jobTitle2" aria-required="true" />
                              </div>
                            </div>


                          </div>
                        </div>
                        
                        
                      </div>

                    </div>
                  </div>
                </div>

              </form>
            </div>
          </div>
          <div className="row cutomStriper">
            <div className="col-lg-12 col-md-12 col-sm-12 col-12">
              {AddClient ?
                <div className="row">
                  <div className="  align-self-start d-flex flex-row-reverse">
                   
                    <button type="button" className="btn btn-info" onClick={() => AddClientData()}> Submit</button>
                    <button type="button" className="btn border bg-white" onClick={() => CloseModal()}> Cancel</button>
                  </div>
                </div>
                : null
              }
              {UpdateClientBtn ?
                <div className=" align-self-start d-flex flex-row-reverse">
                  <button type="button" className="btn btn-info" onClick={() => UpdateClient()}> Update</button>
                  <button type="button" className="btn border bg-white" onClick={() => CloseModal()}> Cancel</button>
                  
                </div>
                : null}
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {/* {ClientList?.length && */}
      <div className="row">
        {ClientList
          ? ClientList.map((item, index) => (
            <div className="col-lg-3 col-md-6 col-sm-12 col-12" key={index}>
              <div className="clientTiles">
                <div className="ClientImg">
                  <div className="tabs_img">
                    <img src={item?.logo} class="img img-responsive" alt="client-img" />
                  </div>
                  <div class="bars_font">
                    <h3
                      className="font_trigger"
                      onClick={() => { setInputValue(item) }}>
                      <FontAwesomeIcon icon={faPenToSquare} />
                    </h3>
                  </div>
                </div>
                <div className="ClientText">
                  <div className="l-two">
                    <h1> {item?.clientDisplayName} </h1>
                    <h4>{item?.email} </h4>
                    <h4> {item?.phoneNumber}</h4>
                    <h4> {item?.addressLine1} {item?.addressLine2}</h4>
                    <h4> {item?.city}, {item?.state}</h4>
                  </div>
                </div>
              </div>
            </div>
          ))
          : null}
      </div>
      {/* } */}
      {!ClientList?.length && ClientList?.length != null && <div className='bg-white' style={{ paddingBottom:"50px", borderRadius: "10px" }}>
        <div className='col-12 text-center'>
          <img src={NoBuilding} alt="user" class="mx-auto mt-5" style={{ height: "100px" }} />
        </div>
        <br />
        <h3 className='col-12 text-center NoDataShowTextColor' style={{ marginTop: "0px", }}> No client found</h3>
        <h5 className='col-12 text-center NoDataShowTextColor' style={{ marginTop: "10px" }}> Click on Create New button to add a client</h5>
      </div>}

    </>
  );
}
export default Client;
